import { withRouter } from "react-router"
import { Formik, Form, Field, ErrorMessage } from 'formik'
import FieldWrapper from '../forms/FieldWrapper'
import ImageDisplayAndUpload from './fields/ImageDisplayAndUpload'
import ButtonSubmitCancel from '../general/ButtonSubmitCancel'
import WrapperAccordion from '../general/WrapperAccordion';
import DatePickerContainer from './fields/DatepickerContainer'
import RadioButtonMovieItem from './fields/SingleSelectRadioButtonMovieItem'
import RadioButtonGroup from './fields/RadioButtonGroup'
import MultiselectCheckboxCinemas from './fields/MultiselectCheckboxCinemas'
import { sanitizeFormInput, sanitizeFormOutput } from '../../functions/formFunctions'
import RadioButton from './fields/SingleSelectRadiobutton'
import config from '../../attribute-position-config.json'
import addFormikData from '../../functions/addFormikData'
import Translation from '../Translation/cont/Translation'
import { MOVIE } from '../../constants/itemTypes'
import ListItemMovieContainer from '../DragAndDropItems/cont/ListItemMovieContainer'

const FormAdData = ({contentData, history, closePagePath, suffixEdit='', onUpdateAD, movieData, sortedMovieDataKeys, cliCinemas, cliCinemasIdList, clientCinemaId, features, transNoMovieSelected}) => {
    const {destinationType, pathType} = config
    const cinemaDomain = cliCinemas[clientCinemaId].website
    const newLinkData = {
        destinationType: "internal",
        pathType: "absolute",
        url: "",
        text: ""
    }
    const linkData = contentData.link ? contentData.link : newLinkData
    
    return (
    <Formik
        initialValues={addFormikData(sanitizeFormInput(contentData, cliCinemas), linkData, "link")}
        onSubmit={(values, actions) => {
            if(!values.link.url || !values.link.text) {
                addFormikData(values, "", "link")
            }

            onUpdateAD(sanitizeFormOutput(values))
            actions.setSubmitting(false)
        }}
        onReset={(values, actions) => {
            history.push(closePagePath)
    }}>
    {({ values, errors, status, touched, isSubmitting, setFieldValue, handleReset }) => (
        <Form>
                <WrapperAccordion
                    className="single-section"
                    selectionActiveClass="accordion-item-open"
                >
                    <fieldset>
                        <div className="form-content ads">
                            <div className="left-sections">
                                <FieldWrapper label={<Translation id="content_title"/>} id="content-title" classes="field-text">
                                    <Field type="text" name="title" id="content-title" className="text-regular input-text-box" />
                                    <ErrorMessage name="title" component="div" /> 
                                </FieldWrapper>

                                <FieldWrapper label={<Translation id="content_short_description"/>} info={<Translation id="content_short_description_info"/>} id="content-text" classes="field-textarea field-textarea-text">
                                    <Field type="text" name="text" wrap="hard" component="textarea" maxLength="220" id="content-text" className="text-regular input-text-box" />
                                    <ErrorMessage name="text" component="div" /> 
                                </FieldWrapper>

                                <FieldWrapper label={<Translation id="content_link_text"/>} id="content-link-text" classes="field-text">
                                    <Field type="text" name="link.text" id="content-link-text" className="text-regular input-text-box" />
                                    <ErrorMessage name="link.text" component="div" /> 
                                </FieldWrapper>

                                <FieldWrapper label={<Translation id="content_link_url"/>} id="content-link-url" classes="field-text">
                                    <Field type="text" name="link.url" id="content-link-url" className="text-regular input-text-box" />
                                    <ErrorMessage name="link.url" component="div" /> 
                                </FieldWrapper>
                                <RadioButtonGroup
                                    label={<Translation id="content_link_target"/>}
                                    description={<Translation id="content_link_target_info"/>}
                                    className="select-new-section-type"
                                >
                                    <ErrorMessage className="text-regular-color movie-error" name="link.destinationType" component="div" /> 
                                    {destinationType.map(type => {
                                        const {transId, id} = type
                                        return (
                                            <Field
                                                key={id}
                                                component={RadioButton}
                                                name="link.destinationType"
                                                id={id}
                                                label={<Translation id={transId}/>}
                                            />
                                        )
                                    })}
                                </RadioButtonGroup>
                                <RadioButtonGroup
                                    label={<Translation id="content_link_type"/>}
                                    description={<Translation id="content_link_type_info" after={' ' + cinemaDomain}/>}
                                    className="select-new-section-type"
                                >
                                    <ErrorMessage className="text-regular-color movie-error" name="link.pathType" component="div" /> 
                                    {pathType.map(type => {
                                        const {transId, id} = type
                                        return (
                                            <Field
                                                key={id}
                                                component={RadioButton}
                                                name="link.pathType"
                                                id={id}
                                                label={<Translation id={transId}/>}
                                            />
                                        )
                                    })}
                                </RadioButtonGroup>
                                <div className="datepicker-container">
                                    <div className="datepicker-wrapper">
                                        {_.has(values, "displayDateStart") && <FieldWrapper label={<Translation id="content_display_start_date"/>} id="startdate" description={<Translation id="content_display_start_date_info"/>} classes="datepicker-inner-wrapper">
                                            <DatePickerContainer value={values.displayDateStart} isStartDate={true} resetValue={'displayDateEnd'} end={values.displayDateEnd} name="displayDateStart" onChange={setFieldValue} type="text" id="startdate" className="text-small-light input-text-box" />
                                            <ErrorMessage name="displayDateStart" component="div" />
                                        </FieldWrapper>}
                                    </div>
                                    <div className="datepicker-wrapper">
                                        {_.has(values, "displayDateEnd") && <FieldWrapper label={<Translation id="content_display_end_date"/>} id="enddate" description={<Translation id="content_display_end_date_info"/>} classes="datepicker-inner-wrapper">
                                            <DatePickerContainer value={values.displayDateEnd} start={values.displayDateStart} name="displayDateEnd" onChange={setFieldValue} type="text" id="enddate" className="text-small-light input-text-box" />
                                            <ErrorMessage name="displayDateEnd" component="div" />
                                        </FieldWrapper>}
                                    </div>
                                </div>
                                {_.has(values, "cinema") && cliCinemas ? (
                                    cliCinemasIdList.length > 1 ? (
                                        <fieldset className="field-cinemas">
                                                <legend className="field-text-label"><Translation id="content_cinemas"/></legend>                                                
                                                <div className="select-all-cinemas-button-wrapper">  
                                                    <div key={'field-all'} className="field-checkbox">
                                                        <Field 
                                                            key={'all'} 
                                                            attrid={'all'}
                                                            name="cinemas"
                                                            component={MultiselectCheckboxCinemas} 
                                                            id={'alle anwählen'}
                                                            clicinemas={'all'}
                                                            value={cliCinemasIdList} 
                                                        />
                                                    </div>
                                                </div>

                                                <div className="grid-container">
                                                    {cliCinemasIdList.map(cinemaId => {
                                                        const cinema = cliCinemas[cinemaId]
                                                        const {pk, nameShort} = cinema

                                                        return (
                                                            <div key={'field' + pk} className="field-checkbox">
                                                                <Field 
                                                                    key={pk} 
                                                                    attrid={pk}
                                                                    name="cinemas"
                                                                    component={MultiselectCheckboxCinemas} 
                                                                    id={nameShort}
                                                                    clicinemas={cliCinemas}
                                                                    value={pk} 
                                                                    movie={movieData[values.movieRefID]}
                                                                />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </fieldset>
                                        ) : (
                                            cliCinemasIdList.map(cinemaId => {
                                                const cinema = cliCinemas[cinemaId]
                                                const {pk, nameShort} = cinema
                                                
                                                return (
                                                    <div key={'field' + pk} className="field-checkbox">
                                                        <Field 
                                                            key={pk} 
                                                            attrid={pk}
                                                            name="cinemas"
                                                            component={MultiselectCheckboxCinemas} 
                                                            id={nameShort}
                                                            clicinemas={cliCinemas}
                                                            value={pk} 
                                                        />
                                                    </div>
                                                )
                                            })
                                        )
                                    ) : (
                                        ''
                                    )
                                }
                                {features && features.has_mcs_app && <div className="field-checkbox field-text">
                                    <label>
                                        <p className="field-text"><Translation id="app_settings"/></p>
                                        <Field type="checkbox" name="showInApp" id="show-in-app" className="checkbox"/>
                                        <span className="show-in-app-text text-regular"><Translation id="app_display" /></span>
                                    </label>
                                    <ErrorMessage className="text-regular-color" name="showInApp" component="div" />
                                </div> }                              
                            </div>

                            <div className="right-sections">
                                <p className="background-description-text text-small-regular">
                                    <Translation id="content_background_image_info"/>
                                </p>
                                <FieldWrapper label={<Translation id="content_background_image"/>} id="content-image" >
                                    <Field 
                                        name="imagePoster"
                                        component={ImageDisplayAndUpload}
                                    />
                                </FieldWrapper>

                                {values.imagePoster ? values.imagePoster.url || values.imagePoster.url ? (
                                <>
                                    <p className='text-small-light'><Translation id={'y-axis'}/></p>
                                    <div className="slidecontainer">
                                        <Field type="range" step="1" min="0" max="100" name="positionY" className="text-regular range-slider input-text-box gap-10" />
                                    </div>
                                    <p className='text-small-light'><Translation id={'x-axis'}/></p>
                                    <div className="slidecontainer">
                                        <Field type="range" step="1" min="0" max="100" name="positionX" className="text-regular range-slider input-text-box" />
                                    </div>
                                </>) : (
                                    ''
                                ) : (
                                    ''
                                )}

                                {sortedMovieDataKeys && !_.isEmpty(movieData) && sortedMovieDataKeys.length > 0 ? (
                                    <RadioButtonGroup
                                        label={<Translation id="content_movie_link"/>}
                                        className="select-new-section-type"
                                    >
                                    <ErrorMessage className="text-regular-color movie-error" name="movieRefID" component="div" /> 
                                        <Field
                                            key={'delete'}
                                            component={RadioButtonMovieItem}
                                            name="movieRefID"
                                            id={undefined}
                                            movie={transNoMovieSelected && {
                                                title: transNoMovieSelected
                                            }}
                                            additionalClass="no-movie"
                                        />
                                        {sortedMovieDataKeys.map((movieID) => {
                                            const movie = movieData[movieID]
                                            const intId = movie.id
                                            const {cinemaIds, title} = movie
                                            const cliCinemas = values.cinemasFilter
                                            const cinemasIntersectionArray = _.intersection(cinemaIds, cliCinemas)
                                            const pathnameEdit = `${closePagePath}/${MOVIE}/${intId}${suffixEdit}`

                                            if(cinemasIntersectionArray.length !== 0 && cinemasIntersectionArray.length === cliCinemas.length) {                                                
                                                return (
                                                    <Field
                                                        key={intId}
                                                        component={RadioButtonMovieItem}
                                                        name="movieRefID"
                                                        id={intId}
                                                        movie={movie}
                                                        label={title}
                                                        pathnameEdit={pathnameEdit}
                                                    />
                                                )
                                            } else {
                                                return (
                                                    <div key={intId} className="movie-item-radio-wrapper">
                                                        <ListItemMovieContainer
                                                            itemType={MOVIE}
                                                            itemData={movie}
                                                            additionalClass='no-selection-possible'
                                                            pathnameEdit={pathnameEdit}

                                                        />
                                                    </div>
                                                )
                                            }
                                        })}
                                    </RadioButtonGroup>
                                ) : (
                                    <p><Translation id="content_no_movies_available"/></p>
                                )}
                            </div>
                        </div>
    
                        <ButtonSubmitCancel
                            transIdCancel="cancel_button"
                            transIdSubmit="save_content_button"
                            disabledCancel={isSubmitting}
                            disabledSubmit={isSubmitting}
                            onCancel={handleReset}
                        />
                    </fieldset>
                </WrapperAccordion>
            </Form>
        )}
    </Formik>
)}

export default withRouter(FormAdData)